import {createSelector} from 'reselect';
import {CommonRootState} from '../types';

export const selectEcowittConnectedAt = (state: CommonRootState) =>
  state.ecowitt.link && state.ecowitt.link.date_connected;

export const selectEcowittConnected = (state: CommonRootState) =>
  state.ecowitt.link !== null;

export const selectEcowittActive = (state: CommonRootState) =>
  state.ecowitt.link !== null && state.ecowitt.link.account.active;

const selectEcowittLink = (state: CommonRootState) => state.ecowitt.link;

export const getEcowittStationList = createSelector(
  selectEcowittLink,
  (link) => {
    if (link !== null) {
      return link.account.weather_stations;
    }
    return [];
  },
);

const getRawCurrentStationId = (state: CommonRootState) =>
  state.ecowitt.currentStation;

export const getCurrentEcowittStation = createSelector(
  getRawCurrentStationId,
  getEcowittStationList,
  (stationId, stationList) => {
    if (stationList.length === 0) {
      return null;
    }
    const currentStation = stationId
      ? stationList.find((item) => item.device_id === stationId) ||
        stationList[0]
      : stationList[0];

    return currentStation;
  },
);
